import { setMenuBarOrientation } from "../actiontypes";
export const setMenuBarOrientationAction = () => {
  return {
    type: setMenuBarOrientation
  };
};
